import { landingApiRequest } from '@/lib/landing-api'
import type { AvatarPiece } from './avatar-custom'

export type AvatarPurchase = {
  id: string
  campaign_id: number
  item_id: number
  item_name: string
  amount_cents: number
  status: 'creating' | 'creation_uncertain' | 'pending' | 'expired' | 'paid'
  pix_key: string | null
  expires_at: string | null
  delivered_at: string | null
  item?: AvatarPiece
}

const base = (campaignId: number) => `/api/donor/campaigns/${campaignId}/avatar`

export function fetchAvatarItemPurchase(
  campaignId: number,
  itemId: number,
  signal?: AbortSignal
) {
  return landingApiRequest<{ purchase: AvatarPurchase | null }>(
    `${base(campaignId)}/items/${itemId}/purchase`,
    { signal, cache: 'no-store' }
  )
}

export function createAvatarItemPurchase(
  campaignId: number,
  itemId: number,
  requestId: string
) {
  return landingApiRequest<AvatarPurchase>(`${base(campaignId)}/purchases`, {
    method: 'POST',
    body: JSON.stringify({ item_id: itemId, request_id: requestId }),
  })
}

export function fetchAvatarPurchase(
  campaignId: number,
  id: string,
  signal?: AbortSignal
) {
  return landingApiRequest<AvatarPurchase>(
    `${base(campaignId)}/purchases/${encodeURIComponent(id)}`,
    { signal, cache: 'no-store' }
  )
}
